export class Api {
  static API = "https://vvteam33.herokuapp.com";
  /*static API = '/api';*/

  static KANTON = '/kanton';
  static KURZARBEIT_VORANMELDUNG = '/kurzArbeitVoranmeldung';
  static COSTUMER = '/costumer';
  static MESSAGE = '/message';
  static ARBEITSLOSENKASSE = '/arbeitslosenkasse';
  static STATISTIK = '/statistik';
}
